package horcrux.frontend.common.views.screens

import horcrux.frontend.common.GlobalAppState
import horcrux.frontend.common.Route
import horcrux.frontend.common.views.chat.ChatContainer
import horcrux.frontend.common.views.components.containers.ViewWithCollectionNavigator
import horcrux.frontend.common.views.navigation.ViewWithNavigationBar
import horcrux.frontend.common.withDefaultCSS
import mui.material.Container
import mui.system.sx
import react.FC
import react.Props
import web.cssom.AlignItems
import web.cssom.px

external interface ChatWithYourCollectionScreenProps : Props {
    var globalAppState: GlobalAppState
}

val ChatWithYourCollectionScreen = FC<ChatWithYourCollectionScreenProps> { props ->
    ViewWithNavigationBar {
        this.route = Route.CHAT_WITH_YOUR_COLLECTION
        this.globalAppState = props.globalAppState
        Container {
            this.maxWidth = "xl"
            this.sx {
                this.marginTop = 50.px
                this.alignItems = AlignItems.center
            }
            this.withDefaultCSS()
            ViewWithCollectionNavigator {
                this.globalAppState = props.globalAppState
                Container {
                    this.maxWidth = "xl"
                    ChatContainer {
                        this.globalAppState = props.globalAppState
                    }
                }
            }
        }
    }
}
